import { memo, useCallback, useContext, useMemo } from 'react';
import clsx from 'clsx';
import { useComponentSettings, useGeneralRoutes } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useLocation } from '@namespace/i18n';
import { useHistory } from '@namespace/router';
import { UserContext } from '@namespace/user';
import { LINE_VIEW, MODE } from '../../../../../constants';
import { useEventLink } from '../../../../../hooks/useEventLink';
import { useEventField, useSportSlugByEventId } from '../../../../../store';
import { markHistoryFrameWithScrollToEl } from '../../../../../utils';
import { EventBodyButton } from './EventBodyButton';
import { EventBodyTable } from './EventBodyTable';

import styles from './index.module.css';

export const EventBody = memo((props) => {
  const {
    headGroups = [],
    eventId,
    isShowEventGroup,
    lineKey,
    isShowStatUrl,
    isDisplayHeadMarkets,
    lineView,
    isLiveEvents
  } = props;
  const { isDesktop } = useDeviceStore();
  const [{ role }] = useContext(UserContext);

  const sportSlug = useSportSlugByEventId(eventId, MODE.IN_PLAY);
  const linkToEventDetail = useEventLink({ eventId });
  const { push } = useHistory();
  const { liveSportAll } = useGeneralRoutes();
  const { pathname } = useLocation();
  const { type } = useComponentSettings();
  const increasedOdds = useEventField(eventId, 'increasedOdds');

  const classNames = useMemo(
    () => ({
      marketsCountClass: clsx(styles.marketsCount, lineView && styles[lineView])
    }),
    [lineView]
  );

  const onEventOpen = useCallback(
    (e) => {
      e.stopPropagation();
      if (pathname === `${liveSportAll}/`) {
        push(`${liveSportAll}/#${sportSlug}`);
      }

      markHistoryFrameWithScrollToEl(e, type);
      push(linkToEventDetail);
    },
    [pathname, liveSportAll, push, linkToEventDetail, sportSlug, type]
  );

  const innerProps = {
    lineView,
    eventId,
    lineKey,
    isLiveEvents,
    isDesktop,
    role,
    isShowStatUrl,
    classNames,
    increasedOdds,
    headGroups,
    isDisplayHeadMarkets,
    isShowEventGroup
  };

  return (
    <div onClick={onEventOpen} data-role={`event-id-${eventId}`}>
      {lineView === LINE_VIEW.TABLE ? (
        <EventBodyTable {...innerProps} />
      ) : (
        <EventBodyButton {...innerProps} />
      )}
    </div>
  );
});

EventBody.displayName = 'EventBody';
